import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMore = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 6,
	viewBox: "0 0 24 6",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillRule: "nonzero",
		d: "M3.01 5.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m8.98 0a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m9 0a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
	})
});
export default SvgMore;
